import * as angular from 'angular';
import * as _ from 'lodash';
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import CommoditiesServiceName, {CommoditiesService} from "../../services/batches/commodities.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import template from './addCommodity.tpl.html';

let requires = [CommoditiesServiceName, NotifyServiceName, LoaderServiceName, NewGuidServiceName];

interface AddCommodityController {
  add(): void;
  cancel(): void;
}

export interface AddCommodityParams {
  plant: Plant;
  allCommodities: apsViewModels.CommodityItem[];
}

export function openAddCommodity(data: AddCommodityParams,
                                 $modal: mm.foundation.modal): angular.IPromise<apsViewModels.CommodityItem> {
  return $modal.open({
    template: template,
    controller: 'AddCommodityCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class AddCommodityCtrl implements AddCommodityController {
  instance: apsViewModels.CommodityItem;
  form: angular.IFormController;
  allCommodities: apsViewModels.CommodityItem[];

  private commoditiesService: CommoditiesService;
  private $modalInstance: mm.foundation.modalInstance;
  private notifyService: NotifyService;
  private loaderService: LoaderService;

  constructor(
    data: AddCommodityParams,
    newGuidService: NewGuidService,
    commoditiesService: CommoditiesService,
    $modalInstance: mm.foundation.modalInstance,
    notifyService: NotifyService,
    loaderService: LoaderService
  ) {
    this.commoditiesService = commoditiesService;
    this.$modalInstance = $modalInstance;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.instance = <apsViewModels.CommodityItem>{
      plantId: data.plant.id,
      plantName: data.plant.name
    };
    this.allCommodities = data.allCommodities;

    newGuidService.getNewGuid('Commodity').then(id => this.instance.id = id);
  }

  add(): void {
    if (this.form.$invalid) {
      return;
    }

    let command = <apsCommands.AddCommodity>this.instance;

    this.loaderService.loadingPromise(this.commoditiesService.add(command)
      .then(() => {
        this.$modalInstance.close(this.instance);
      }, this.notifyService.handleApiErrors)
    );
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.addCommodity', requires)
  .controller('AddCommodityCtrl', AddCommodityCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/addCommodity.controller.ts